export default __webpack_public_path__ + "static/media/QRMDC.3453d749.png";